<template>
    <v-container fluid class="px-0 pb-0">
        <v-card v-if="!loading">
            <v-row class="mx-1">
                <v-col
                    :md="tab != 4 ? 10 : 12"
                    cols="12"
                    class="d-flex align-center"
                >
                    <v-tabs v-model="tab" fixed-tabs center-active>
                        <v-tab
                            v-for="item in items"
                            :key="item.tab"
                            class="primary--text"
                        >
                            {{ item.tab }}
                            <v-icon color="primary">{{ item.icon }}</v-icon>
                        </v-tab>
                    </v-tabs>
                </v-col>
                <v-col
                    v-if="tab != 4"
                    md="2"
                    cols="12"
                    :class="`d-flex align-center flex-wrap ${
                        $vuetify.breakpoint.xs
                            ? 'justify-center'
                            : 'justify-end'
                    }`"
                >
                    <v-badge
                        :content="numNotNull"
                        :value="numNotNull"
                        color="red"
                        overlap
                    >
                        <v-btn
                            outlined
                            small
                            :class="
                                !$vuetify.breakpoint.mdAndDown ? 'mb-1' : 'ma-1'
                            "
                            color="primary"
                            :loading="loadingItems"
                            @click="openFilterForm()"
                        >
                            {{ $vuetify.breakpoint.mdAndDown ? '' : 'Filtrar' }}
                            <v-icon :right="!$vuetify.breakpoint.mdAndDown">
                                mdi-filter
                            </v-icon>
                        </v-btn>
                    </v-badge>
                    <v-btn
                        small
                        outlined
                        :class="
                            !$vuetify.breakpoint.mdAndDown ? 'ml-2 mb-1' : ''
                        "
                        color="red"
                        @click="reset()"
                    >
                        {{ $vuetify.breakpoint.mdAndDown ? '' : 'Restablecer' }}
                        <v-icon :right="!$vuetify.breakpoint.mdAndDown">
                            mdi-close
                        </v-icon>
                    </v-btn>
                </v-col>
            </v-row>

            <v-tabs-items v-model="tab">
                <v-tab-item v-for="item in items" :key="item.tab">
                    <component :is="item.component"></component>
                </v-tab-item>
            </v-tabs-items>
            <ManagementConfirmDeletion />
            <BaseManagementForm />
            <ManagementFilterForm />
        </v-card>
        <div id="fullHeigth"></div>
    </v-container>
</template>

<script>
import TariffManagement from '@/components/GerenciaTeletrabajo/Management/TariffManagement/TariffManagementTable.vue';
import PromotionManagement from '@/components/GerenciaTeletrabajo/Management/PromotionManagement/PromotionManagementTable.vue';
import SVAManagement from '@/components/GerenciaTeletrabajo/Management/SVAManagement/SVAManagementTable.vue';
import AdditionalManagement from '@/components/GerenciaTeletrabajo/Management/AdditionalManagement/AdditionalManagementTable.vue';
import INDBOPROManagement from '@/components/GerenciaTeletrabajo/Management/INDBOPROManagement/INDBOPROManagementBase.vue';
import ManagementConfirmDeletion from '@/components/GerenciaTeletrabajo/Management/ManagementConfirmDeletion.vue';
import BaseManagementForm from '@/components/GerenciaTeletrabajo/Management/BaseManagementForm.vue';
import ManagementFilterForm from '@/components/GerenciaTeletrabajo/Management/ManagementFilterForm.vue';

import { clone } from '@/util/libUtil.js';
import defaultManagementFilters from '@/util/management/defaultManagementFilters.js';
import { mapState } from 'vuex';

export default {
    name: 'Management',
    components: {
        TariffManagement,
        PromotionManagement,
        SVAManagement,
        AdditionalManagement,
        INDBOPROManagement,
        ManagementConfirmDeletion,
        BaseManagementForm,
        ManagementFilterForm,
    },
    data: () => ({
        loading: false,
        tab: 0,
        items: [
            { tab: 'Tarifas', icon: 'mdi-tag', component: 'TariffManagement' },
            {
                tab: 'Adicionales',
                icon: 'mdi-tag-plus',
                component: 'AdditionalManagement',
            },
            { tab: 'SVA', icon: 'mdi-cart-plus', component: 'SVAManagement' },
            {
                tab: 'Promociones',
                icon: 'mdi-sale',
                component: 'PromotionManagement',
            },
            {
                tab: 'Stuff',
                icon: 'mdi-developer-board',
                component: 'INDBOPROManagement',
            },
        ],
    }),
    methods: {
        across(){
            const OFFSET = 100;
            //this.loading = true;
            console.log(this.items.length);

            for (let i = 0; i < this.items.length; i++) {
                setTimeout(() => {
                    this.tab = i;
                }, OFFSET);
            }

            setTimeout(() => {
                this.tab = 0;
                this.loading = false;
            }, this.items.length * OFFSET);
        },
        openFilterForm() {
            this.$store.commit(
                'ManagementBase/isOpenManagementFilterForm',
                true
            );
        },
        reset() {
            this.$store.commit(
                'ManagementBase/managementFilterForm',
                clone(defaultManagementFilters)
            );
        },
    },
    computed: {
        numNotNull() {
            let count = 0;
            Object.keys(this.managementFiltersForm).forEach((item) => {
                if (this.managementFiltersForm[item] != null) count++;
            });
            return count;
        },
        ...mapState('ManagementBase', {
            loadingItems: (state) => state.loadingItems,
            managementFiltersForm: (state) => state.managementFilters.form,
            isActive: (state) => state.baseForm.isActive,
            item_id: (state) => state.baseForm.item_id,
        }),
        ...mapState('util', {
            search: (state) => state.navBarSearchField,
        }),
    },
    beforeCreate() {
        let endpoints = [
            'ManagementBase/additionalManagement/getAdditionals',
            'ManagementBase/promotionManagement/getPromotions',
            'ManagementBase/promotionManagement/getTariffDropDown',
            'ManagementBase/SVAManagement/getSVA',
            'ManagementBase/insuranceManagement/getInsurances',
            'ManagementBase/objectiveTypesManagement/getObjectives',
            'ManagementBase/dboriginManagement/getOrigins',
            'ManagementBase/procedureManagement/getProcedures',
            'ManagementBase/fetchTipoObjetivo',
        ];

        endpoints.forEach((element) => {
            this.$store.dispatch(element);
        });
    },
    watch: {},
    created(){
        this.across()
    }
};
</script>

<style>
#fullHeigth {
    height: 100vh;
    width: 0;
    position: absolute;
}
</style>
<style lang="scss">
.v-slide-group__prev {
    display: none !important;
}
</style>
